import { render } from "./StrategyInfo.vue?vue&type=template&id=5c1275a4&scoped=true&ts=true"
import script from "./StrategyInfo.vue?vue&type=script&lang=ts"
export * from "./StrategyInfo.vue?vue&type=script&lang=ts"

import "./StrategyInfo.vue?vue&type=style&index=0&id=5c1275a4&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1275a4"]])

export default __exports__